/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_4_LinkInputs */

const en_mk_sec_4_link = /** @type {(inputs: Mk_Sec_4_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read about Proof-of-Done`)
};

const id_mk_sec_4_link = /** @type {(inputs: Mk_Sec_4_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baca soal Proof-of-Done`)
};

/**
* | output |
* | --- |
* | "Read about Proof-of-Done" |
*
* @param {Mk_Sec_4_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_4_link = /** @type {((inputs?: Mk_Sec_4_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_4_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_4_link(inputs)
	return en_mk_sec_4_link(inputs)
});